export default "__VITE_ASSET__eWb7QHfg__"